import { render, staticRenderFns } from "./OrdonnanceEdit.vue?vue&type=template&id=759036d8&"
import script from "./OrdonnanceEdit.vue?vue&type=script&lang=js&"
export * from "./OrdonnanceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports